export default {
  setLocale(state, { locale }) {
    state.currentLocale = locale;
    window.localStorage.setItem('locale', locale);
  },
  init(state, { locale }) {
    state.currentLocale = locale || state.currentLocale;
  },
};
